// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"f14b85fc","133":"84633f8a","182":"5890a2df"}[chunkId] + ".chunk.js";
};